module.exports = __webpack_public_path__ + "img/meh-rolling-eyes.0a099706.svg";